<template>
  <section id="how-to" :class="{ teaser : isTeaser }">
    <h4>In 4 Schritten zur professionellen Website</h4>
    <section id="explanation">
      <section>
        <img src="../assets/img/icons/howto/funktionen-konfigurieren.svg" alt="Konfiguration" />
        <h5 id="first-step">Funktionsumfang konfigurieren</h5>
      </section>
      <section>
        <img src="../assets/img/icons/howto/angebot-erhalten.svg" alt="Angebot erhalten" />
        <h5 id="second-step">Kostenloses Angebot erhalten</h5>
      </section>
      <section>
        <img src="../assets/img/icons/howto/design-hochladen.svg" alt="Design hochladen" />
        <h5 id="third-step">Ihre Designs hochladen</h5>
      </section>
      <section>
        <img src="../assets/img/icons/howto/wir-programmieren.svg" alt="Ihr Programmierer" />
        <h5 id="fourth-step">Wir programmieren Ihr Design</h5>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'HowTo',
  props: {
    isTeaser: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#how-to {
  background: #393939;
  width: 100%;
  padding: 60px 15px 50px 15px;
  h4 {
    color: #fff;
    font-family: $primaryFont;
    font-weight: $primaryFontBold;
    font-size: 20px;
    margin: 0 0 10px 0;
    line-height: 1.4;
    text-align: center;
  }
  #explanation {
    display: flex;
    flex-direction: column;
    section {
      width: 100%;
      padding: 20px 20px 10px 20px;
      display: flex;
      justify-content: start;
      flex-direction: column;
      text-align: center;
      position: relative;
      img {
        width: auto;
        height: 80px;
        margin-bottom: 15px;
      }
      h5 {
        color: #fff;
        font-family: $secondaryFont;
        font-weight: $secondaryFontNormal;
        font-size: 16px;
        margin: 0;
        line-height: 1.4;
        &#first-step {
          &:before {
            content: '1. ';
          }
        }
        &#second-step {
          &:before {
            content: '2. ';
          }
        }
        &#third-step {
          &:before {
            content: '3. ';
          }
        }
        &#fourth-step {
          &:before {
            content: '4. ';
          }
        }
      }
    }
  }
}
@media (min-width:360px) {
  #how-to {
    h4 {
      margin: 0 0 20px 0;
    }
    #explanation {
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      section {
        width: 50%;
        padding: 30px 5px 20px 5px;
        // width: 48%;
      }
    }
  }
}
@media (min-width:560px) {
  /*
  #how-to {
    padding: 60px 15px 60px 15px;
    h4 {
      margin: 0 0 40px 0;
    }
    #explanation {
      flex-direction: row;
      z-index: 1;
      section {
        // width: 33.3333%;
        width: 25%;
        padding: 0 5px;
        h5 {
          font-size: 14px;
        }
      }
    }
  }
  */
}
@media (min-width:767px) {
  #how-to {
    padding: 80px 30px 80px 30px;
    h4 {
      font-size: 22px;
    }
    #explanation {
      section {
        width: 25%;
        padding: 20px 5px 5px 5px;
        img {
          margin-bottom: 15px;
        }
        h5 {
          font-size: 16px;
          &:before {
            display: none;
          }
        }
        &:after {
          position: absolute;
          display: block;
          top: 30%;
          right:-5px;
          width: 15px;
          height: 28px;
          content: '';
          background-size: 15px 28px;
          background-image: url('../assets/img/icons/chevron.svg');
          background-repeat: no-repeat;
          background-position: center;
        }
        &:last-child {
          &:after {
            display: none;
          }
        }
      }
    }
  }
}
@media (min-width:960px) {
  #how-to {
    #explanation {
      section {
        img {
          height: 100px;
          margin-bottom: 20px;
        }
        h5 {
          font-size: 17px;
        }
        &:after {
        }
      }
    }
  }
}
@media (min-width:1080px) {
  #how-to {
    #explanation {
      section {
        img {
        }
        h5 {
          font-size: 18px;
        }
        &:after {
        }
      }
    }
  }
}
</style>
